export class ModalEntry<E, R> {
    _paramenterTypeAnchor: E;
    _resultTypeAnchor: R;
}
